export const excelFileManifest = {
    TurfBox: ['TurfBox/Cihaz-84285.xlsx', 'TurfBox/Cihaz-84285-Temp.xlsx'],
  Unite: [],
  Sulama: ['Sulama/VanaListesi.xlsx', 'Sulama/LokasyonBazliToprakVerileri.xlsx'],
  Isitma: []
};

export const fetchFolderManifest = async (folder) => {
  try {
    const response = await fetch(`/data/${folder}/manifest.json`, { cache: 'no-store' });

    if (!response.ok) {
      return [];
    }

    const payload = await response.json();
    const files = Array.isArray(payload) ? payload : payload?.files;

    if (!Array.isArray(files)) {
      return [];
    }

    return files.map((fileName) => {
      if (fileName.startsWith(`${folder}/`)) {
        return fileName;
      }
      return `${folder}/${fileName}`;
    });
  } catch (error) {
    console.warn('📁 Manifest okunamadı:', error);
    return [];
  }
};

export const fetchUnitManifest = () => fetchFolderManifest('Unite');
